<template>
  <div class="space-y-8">
    <NuxtImg
      :src="props.image"
      :alt="props.name"
      class="h-full w-full object-cover min-h-[250px] max-h-[300px]"
      format="webp"
    />

    <div class="space-y-2">
      <div class="text-3xl lg:text-[40px] lg :leading-[49.1px]">
        {{ props.title }}
      </div>
      <div class="font-general-sans text-xl">
        {{ props.name }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  image: {
    type: String
  },
  title: {
    type: String
  },
  name: {
    type: String
  }
})
</script>

<style></style>
